<script>
    import { mapState } from "vuex";
    import FooterMenuList from "@/components/footer/FooterMenuList";
    import TheSocialLinks from "@/components/TheSocialLinks";
    import FooterFeedback from "@/components/footer/FooterFeedback";
    import LinkWithAnalytics from "@/components/LinkWithAnalytics";
    import TheContactsEmails from "@miku-kz/components/TheContactsEmails";

    export default {
        name: "TheFooterMain",
        components: {
            TheContactsEmails,
            FooterFeedback,
            FooterMenuList,
            TheSocialLinks,
            LinkWithAnalytics,
        },
        computed: {
            ...mapState("Root", {
                bottomMenu: (state) => state.site.bottomMenu,
                centerMenu: (state) => state.site.mainMenu,
                phoneCallCenter: (state) => state.site.options.phoneCallCenter,
            }),
            getCurrentYear() {
                return new Date().getFullYear();
            },
        },
    };
</script>

<template>
    <div class="the-footer-main">
        <div class="l-container">
            <div class="the-footer-main__inner">
                <div class="the-footer-main__feedback">
                    <footer-feedback></footer-feedback>
                </div>

                <div class="the-footer-main__navigation">
                    <div class="the-footer-main__menu">
                        <footer-menu-list :list="centerMenu" is-main>
                            <li class="footer-menu-list__item">
                                <router-link
                                    :to="{ name: 'Home', hash: '#media' }"
                                    class="footer-menu-list__link"
                                >
                                    Медиа о нас
                                </router-link>
                            </li>
                            <li class="footer-menu-list__item">
                                <router-link
                                    :to="{ name: 'Home', hash: '#about' }"
                                    class="footer-menu-list__link"
                                >
                                    О бренде
                                </router-link>
                            </li>
                        </footer-menu-list>
                    </div>
                    <div class="the-footer-main__menu">
                        <footer-menu-list :list="bottomMenu" is-main></footer-menu-list>
                    </div>
                </div>

                <div class="the-footer-main__info">
                    <router-link
                        :to="{ name: 'Home' }"
                        class="the-footer-main__logo"
                    ></router-link>

                    <div class="the-footer-main__copyright">
                        © {{ getCurrentYear }} miku.kz<br />
                        Все права защищены
                    </div>

                    <div class="the-footer-main__emails">
                        <link-with-analytics
                            class="the-footer-main__phone"
                            type="phone"
                            :text="phoneCallCenter"
                        ></link-with-analytics>
                        <the-contacts-emails></the-contacts-emails>
                    </div>

                    <div class="the-footer-main__social">
                        <the-social-links
                            telegram="https://t.me/mikurussia"
                        ></the-social-links>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .the-footer-main {
        background-color: #25323f;
    }

    .the-footer-main__inner {
        padding: 30px 0 40px;
        @include bp($bp-desktop-sm) {
            display: flex;
            justify-content: space-between;
            padding-bottom: 30px;
        }
    }

    .the-footer-main__feedback {
        margin-bottom: 30px;
        @include bp($bp-desktop-sm) {
            order: 1;
            max-width: 360px;
            width: 100%;
            margin-bottom: 0;
        }
        @include bp($bp-desktop-lg) {
            max-width: 400px;
        }
    }

    .the-footer-main__navigation {
        display: flex;
        margin: 0 -15px 60px;
        @include bp($bp-desktop-sm) {
            margin: 0;
        }
    }

    .the-footer-main__menu {
        flex-basis: 50%;
        max-width: 50%;
        padding: 0 15px;
        @include bp($bp-desktop-sm) {
            min-width: 175px;
            margin-right: 20px;
            padding: 0;
        }
        @include bp($bp-desktop-lg) {
            margin-right: 40px;
        }
    }

    .the-footer-main__emails {
        margin-bottom: 32px;
        order: -1;
        @include bp($bp-desktop-sm) {
            order: initial;
        }
    }

    .the-footer-main__info {
        display: flex;
        flex-direction: column;
        text-align: center;
        @include bp($bp-desktop-sm) {
            order: -1;
            margin-right: auto;
            text-align: left;
        }
    }

    .the-footer-main__logo {
        display: block;
        width: 120px;
        height: 30px;
        margin: 0 auto 20px;
        background-image: url("/static/miku-kz/logo-light.svg?v=181022");
        background-size: contain;
        background-repeat: no-repeat;
        @include bp($bp-desktop-sm) {
            margin: 0 0 20px;
        }
    }

    .the-footer-main__copyright {
        margin-bottom: 20px;
        color: #acbccc;
        font-size: 12px;
        line-height: 18px;
    }

    .the-footer-main__phone {
        display: block;
        margin-bottom: 5px;
        color: #fff;
        font-size: 24px;
        font-weight: 600;
        line-height: 22px;
        transition: color 0.2s ease-in;
        &:hover {
            color: #1c92ff;
        }
        @include bp($bp-desktop-sm) {
            font-size: 18px;
        }
    }
</style>
